<template>
  <div>
    <div class="row">
      <div class="col-md-12" style="text-align: center;">
        <h5 v-if="!complete">
          Loading {{ loadingProgress.loaded }} of {{ loadingProgress.total }}
        </h5>
        <h5 v-else>An Excel file is being generated. Check your Downloads folder.</h5>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Constants from '@/utilities/constants'

export default {
  props: ['data'],
  computed: {
    ...mapGetters({
      loadingProgress: 'tasks/search/loadingProgress',
    }),
    complete() {
      return this.loadingProgress.loaded === this.loadingProgress.total
    }
  },
  data() {
    return {
      todo: 'tbd'
    }
  },
  watch: {
    complete() {
      if (this.complete) {
        setTimeout(() => this.$emit('close'), Constants.TIME.MILLIS.THREE_SECONDS)
      }
    },
  }
}
</script>
